var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"right"}},[_c('Page',{attrs:{"total":_vm.total,"show-elevator":"","show-sizer":"","show-total":"","current":_vm.params.page,"page-size":_vm.params.size},on:{"update:current":function($event){_vm.$set(_vm.params, "page", $event)},"on-change":_vm.pageChange,"on-page-size-change":_vm.sizeChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a9944f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../projectCore/src/components/page/src/index.vue
// module id = null
// module chunks = 